import React from "react";
import styled from "styled-components";
import * as Icon from "react-feather";
import { H5, P } from "../Texts";

import fallbackImg from "../../../assets/images/UNLogo.png";

const OrganizationsCardStyle = styled.div`
  border-radius: 8px;
`;

export const OrganizationCard = ({
  description,
  location,
  logo = fallbackImg,
  title,
  width,
}) => {
  return (
    <OrganizationsCardStyle
      width={width}
      className="bg-white p-5 flex justify-between shadow hover:shadow-md duration-300"
    >
      <div className="flex truncate items-center">
        <img src={logo} alt="" className="h-10 w-12 mr-4" />
        <div className="truncate">
          <H5
            color="#442ED0"
            fontSize="16px"
            smallSize="16px"
            className="mb-0 font-semibold truncate"
          >
            {title}
          </H5>
          {location ? (
            <div className="flex items-center">
              <Icon.MapPin fill="#9390B0" color="#fff" size={14} className="mr-2" />
              <P
                color="#413E53"
                fontSize="14px"
                smallSize="14px"
                className="my-0 truncate"
              >
                {location}
              </P>
            </div>
          ) : (
            <P
              color="#413E53"
              fontSize="14px"
              smallSize="14px"
              className="my-0 truncate"
            >
              {description}
            </P>
          )}
        </div>
      </div>
    </OrganizationsCardStyle>
  );
};
